import { createSelector } from 'reselect';
import { utcToZonedTime } from 'date-fns-tz';
import format from 'date-fns/format';
import { createGamePkSelector } from '@gameday/utils/selectors/getGameStaticData';

const stitchEnv = {
    local: 'prod',
    beta: 'prod',
    dev: 'prod'
};

const getGamePicker = (state) => {
    return {
        ...state.gamePicker
    };
};

const getGamePickerDate = (state) => format(utcToZonedTime(state?.gamePicker?.date, 'America/New_York'), 'yyyy-MM-dd');
const getLanguage = (state) => state.config?.language;
const getDictionary = (state) => state.config?.dictonary;
const getLoading = (state) => state.loading?.isLoading;
const getLocalTimezone = (state) => state.config?.localTimezone;
const getEnv = (state) => {
    const { env } = state?.views || {};
    return stitchEnv[env] || env || 'prod';
};

const mergeList = (listA = [], listB = []) => {
    const list = listA.concat(listB);
    return list.filter((item, pos) => list.indexOf(item) === pos);
};

const getSportIdsLeagueIdsHelper = (state) => {
    const { sportId, leagues, homeLeagueId, awaySportId, awayLeagueId, gamePk } = state?.gamePicker || {};
    const { sportIds, leagueIds } = state?.config || {};

    const sportIdArray = Array.isArray(sportId) ? sportId : sportId?.toString()?.split(',');
    const leaguesArray = Array.isArray(leagues) ? leagues : leagues?.toString()?.split(',');
    const sportIdsSet = new Set(sportIds);
    const leagueIdsSet = new Set(leagueIds);
    const homeMatched = sportIdsSet.has(sportId?.toString()) || leagueIdsSet.has(homeLeagueId?.toString());
    const awayMatched = leagueIdsSet.has(awaySportId?.toString()) || leagueIdsSet.has(awayLeagueId?.toString());

    if (homeMatched || awayMatched) {
        return {
            sports: mergeList(sportIdArray, sportIds),
            leagues: mergeList(leaguesArray, leagueIds),
            gamePk
        };
    }

    return {
        sports: sportIdArray,
        leagues: leaguesArray,
        gamePk
    };
};

const getSportIdsLeagueIdsSelector = createGamePkSelector(
    getSportIdsLeagueIdsHelper,
    (contextObject) => contextObject
);

export const getGamePickerState = createSelector(
    [getGamePickerDate, getLoading, getLanguage, getEnv, getLocalTimezone, getSportIdsLeagueIdsSelector, getDictionary],
    (date, loading, language, env, localTimezone, { sports, leagues, gamePk }, dictionary) => {
        return {
            date,
            gamePk,
            sportId: sports,
            leagues,
            loading,
            language,
            env,
            localTimezone,
            dictionary
        };
    }
);
